import React from 'react'
import { useDispatch } from 'react-redux';
import { PageType } from './Constants';
function Header(props) {
  const {Pagetype,Title}=props;
  const dispatch=useDispatch();
  const handlePrevClick=()=>{
        dispatch({type:'SET_PAGE',payload:'MAIN'});
  }
  return (
    <div className="Header">
        {Pagetype!=PageType.MAIN_PAGE && <i className="fa-solid fa-less-than backBtn" title="Back" onClick={handlePrevClick}/>}
        <h1 className="title">{Title}</h1>  
    </div>
  )
}

export default Header